import React from 'react'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import Exporting from "highcharts/modules/exporting";
import OfflineExporting from 'highcharts/modules/offline-exporting';
import { getMonthDateYearTimePeriod } from 'helpers/DateUtil'

Exporting(Highcharts);
OfflineExporting(Highcharts)
NoDataToDisplay(Highcharts);

class Stock extends React.Component {
  render() {
    const {
      title,
      data,
      additionalOptions
    } = this.props

    const options = {
      title: {
        text: title,
        spacingBottom: 30
      },
      series: data,
      yAxis: {
        title: {
          text: 'Number of Projects'
        },
        minorTicks: true,
      },
      tooltip: {
        pointFormat: '{series.name}: <b> {point.y:.f} <b><br/>',
        shared: true
      },
      legend: {
        enabled: true,
        maxHeight: '100'
      },
      credits: {
        text: `Source: Fulcrum (nvidia.com) <br /> ${getMonthDateYearTimePeriod(new Date())}`,
        href: false,
        style: {
          cursor: 'default'
        },
        position: {
          align: 'right',
          verticalAlign: 'bottom',
          y: -20
        }
      },
      lang: {
        noData: "No data available",
      },
      responsive: {  
        rules: [{  
          condition: {  
            maxWidth: 100
          },  
          chartOptions: {  
            legend: {  
              enabled: false  
            }  
          }  
        }]
      },
      exporting: {
        fallbackToExportServer: false,
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG','downloadJPEG']
          }
        }
      }
    }

    if (additionalOptions) {
      Object.assign(options, additionalOptions); 
    }

    return (
      <div>
        <HighchartsReact
          immutable={true}
          highcharts={Highcharts}
          constructorType={'stockChart'}
          options={options}
        />
      </div>
    );
  }
}

export default Stock
